/**
 * Play a short beep sound using the Web Audio API.
 * Duration: 100ms, frequency: 880Hz (A5).
 */
export function playBeep() {
  try {
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(880, audioCtx.currentTime);
    gainNode.gain.setValueAtTime(0.3, audioCtx.currentTime);
    // Fade out to avoid click
    gainNode.gain.exponentialRampToValueAtTime(
      0.001,
      audioCtx.currentTime + 0.1
    );

    oscillator.start(audioCtx.currentTime);
    oscillator.stop(audioCtx.currentTime + 0.1);

    // Clean up after the beep
    oscillator.onended = () => {
      gainNode.disconnect();
      oscillator.disconnect();
      audioCtx.close();
    };
  } catch {
    // Web Audio API not available; silently ignore
  }
}
